export default [
	//分类管理列表
	{
		path: 'category',
		name: 'm_category',
		props: route => route.params,
		component: () => import('@/pages/spv/category_list')
	},
	//品牌管理列表
	{
		path: 'brand',
		name: 'm_brand',
		props: route => route.params,
		component: () => import('@/pages/spv/brand_list')
	},
	//系列数据管理列表
	{
		path: 'series',
		name: 'm_series',
		props: route => route.params,
		component: () => import('@/pages/spv/series_list')
	},
	//型号数据管理列表
	{
		path: 'model',
		name: 'm_model',
		props: route => route.params,
		component: () => import('@/pages/spv/model_list')
	},
	//属性数据管理列表
	{
		path: 'attribute',
		name: 'm_attribute',
		props: route => route.params,
		component: () => import('@/pages/spv/attribute_list')
	},
	//属性值数据管理列表
	{
		path: 'attribute_value',
		name: 'm_attribute_value',
		props: route => route.query,
		component: () => import('@/pages/spv/attribute_value_list')
	},
	//质检数据管理列表
	{
		path: 'release',
		name: 'm_release',
		props: route => route.query,
		component: () => import('@/pages/spv/release_list')
	},
	//质检模板管理列表
	{
		path: 'template',
		name: 'm_release_template',
		props: route => route.query,
		component: () => import('@/pages/spv/template_list')
	},
	//报价分类表
	{
		path: 'quotation/type',
		name: 'm_quotation_type',
		props: route => route.query,
		component: () => import('@/pages/spv/quotation_type_list')
	},
	//报价单表
	{
		path: 'quotation',
		name: 'm_quotation_info',
		props: route => route.query,
		component: () => import('@/pages/spv/quotation_info_list')
	}
];